export function restoreMacroQuizState(profile, onboardingData, locationState) {
  const saved = { ...(onboardingData || {}), ...(profile || {}) };
  const unitSystem = saved.units || saved.unit_system ||
    ((saved.height_ft != null || saved.weight_lbs != null) ? 'imperial'
      : ((saved.height_cm != null || saved.weight_kg != null || saved.height != null || saved.weight != null) ? 'metric' : 'imperial'));
  const heightCm = saved.height_cm ?? saved.height;
  const weightKg = saved.weight_kg ?? saved.weight;
  return {
    step: locationState?.returnToStep === 4 ? 4 : 1,
    unitSystem,
    workouts: saved.workout_types || saved.workouts || saved.workouts_selected || [],
    formData: {
      age: saved.age ?? '',
      sex: saved.sex || saved.gender || '',
      height: heightCm ?? '',
      heightFeet: saved.height_ft != null ? saved.height_ft
        : (heightCm != null ? Math.floor(Number(heightCm) / 30.48) : ''),
      heightInches: saved.height_in != null ? saved.height_in
        : (heightCm != null ? Math.round((Number(heightCm) / 2.54) % 12) : ''),
      weight: unitSystem === 'imperial'
        ? (saved.weight_lbs ?? (weightKg != null ? Number((Number(weightKg) * 2.2046226218).toFixed(1)) : ''))
        : (weightKg ?? ''),
      activity_level: saved.activity_level || '',
    },
  };
}

export function restoreFoodPreferences(profile) {
  return {
    allergens: profile?.allergens || profile?.allergies || [],
    dislikes: profile?.dislikes || [],
  };
}
